import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col, DatePicker, Spin, Table, Switch } from 'antd';
import BaseListing from 'src/BaseListings';
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper';
import { wtFormatRoundedValue } from 'src/helpers/commons/utils';
import WidgetBankAccountSelector from 'src/widgets/Selectors/WidgetBankAccountSelector';
const JVReport = () => {
    const Base = new BaseListing('jv_report');
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [Data, setData] = useState([]);
    const [BankAccounts, setBankAccounts] = useState([])
    const [BankAccountId, setBankAccountId] = useState(0)
    const [BankAccountName, setBankAccountName] = useState('')
    const [dateRange, setDateRange] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const changeValues = (key, val) => {
        setData([]);

        if (key === 'date_range') {
            setDateRange(val);
        }
        if (key === 'bank_account_id') {
            setBankAccountId(val.value)
            setBankAccountName(val.label)
        }

    };
    useEffect(() => {
        Base.dropdownData('bank_accounts', {}, [setBankAccounts], 1);
    }, []);

    const getReportData = () => {
        if (dateRange.length < 2) {
            lzNotifyErrorMessageFromResult("Please select date range");
            return;
        }
        const fromDate = dateRange[0];
        const toDate = dateRange[1];
        setIsLoading(true);
        wtApiCall(
            'reports/cheque_signing_report',
            {
                from_date: fromDate.format('YYYY-MM-DD'),
                to_date: toDate.format('YYYY-MM-DD'),
                bank_account_id: BankAccountId
            },
            'get',
            (response) => {
                setData(response.data);
                setIsLoading(false);
            },
            (error) => {
                lzNotifyErrorMessageFromResult(error);
                setIsLoading(false);
            },
        );
    };
    const columns = [
        {
            title: 'Date',
            dataIndex: 'voucher_date',
            key: 'voucher_date',
            width: '8%'
        },
        {
            title: 'Voucher No',
            dataIndex: 'jv_number',
            key: 'jv_number',
            render: (text, record) => {
                return `${record.type_short_name} - ${record.company_voucher_no} - ${record.voucher_no}`;
            },
            width: '8%'
        },
        {
            title: 'Bank Name',
            dataIndex: 'bank_account',
            key: 'bank_account',
            render: bank_account => bank_account ? bank_account.name : '',
            width: '8%'
        },
        {
            title: 'Account No',
            dataIndex: 'bank_account',
            key: 'bank_account',
            render: bank_account => bank_account ? bank_account.account_no : '',
            width: '8%'
        },
        {
            title: (
                <div>
                    <span style={{ marginRight: '80%' }}>Memo</span>
                    <span style={{}}>Amount</span>
                </div>
            ),
            key: 'details',
            render: (text, record) => {
                return (
                    <>
                        {record.detail.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '4px 0',
                                }}
                            >
                                <span style={{ flex: 2.5 }}>{item.narration || '-'}</span>
                                <span style={{ flex: 0.5 }}>
                                    {wtFormatRoundedValue(item.credit, '')}
                                </span>
                            </div>
                        ))}
                    </>
                );
            },
            width: '52%',
        },
        {
            title: 'Cheque in Favor of',
            key: 'reference',
            width: '8%',
            ellipsis: true,
            render: (text, record) => {
                const reference = record.reference?.trim();
                const partyName = record.detail?.[0]?.party_name?.trim();
                return reference || partyName || '-';
            },
            onCell: () => ({
                style: { whiteSpace: 'normal', wordWrap: 'break-word' },
            }),
        },
        {
            title: 'Cheque No',
            dataIndex: 'cheque_no',
            key: 'cheque_no',
            width: '8%'
        },


    ];

    return (
        <div className='container-fluid' style={{ padding: "1em", backgroundColor: "white", minHeight: "100vh", fontFamily: "Helvetica" }}>
            <Form
                layout={'vertical'}
                form={form}
                onFinish={getReportData}
                style={{ maxWidth: "100%", margin: '0 auto' }}
            >
                <Card style={{ width: "100%" }} title={<span style={{ fontSize: '26px', marginLeft: "45%" }}>Cheque Signing Report</span>}>
                    <Row gutter={[24, 24]}>
                        <Col xs={15} sm={10} md={6}>
                            <label>Date Range: *</label>
                            <DatePicker.RangePicker
                                onChange={(value) => {
                                    setDateRange(value);
                                    if (value && value.length === 2) {
                                        setFromDate(value[0].format('YYYY-MM-DD'));
                                        setToDate(value[1].format('YYYY-MM-DD'));
                                    }
                                }}
                                style={{ width: '100%', height: 35 }}
                                value={dateRange}
                            />
                        </Col>
                        <Col xs={15} sm={10} md={6}>
                            <label>Bank Account</label>
                            <WidgetBankAccountSelector
                                value={BankAccountId}
                                displayValue={BankAccountName}
                                bank_accounts={BankAccounts}
                                onChange={(values) => changeValues('bank_account_id', values)}
                            // reloadDropdownData={() => reloadBankAccounts()}
                            />
                        </Col>
                        <Col xs={12} sm={8} md={5}>
                            <Button style={{ marginTop: 30, marginRight: 5 }} type="primary" htmlType="submit" disabled={isLoading ? true : false}>
                                Search
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </Form>
            <Card style={{ marginTop: 30 }}>
                <Spin spinning={isLoading}>
                    <Table
                        columns={columns}
                        dataSource={Data}
                        rowKey="id"
                        pagination={false}
                        bordered
                    />
                </Spin>
            </Card>
        </div>
    );
};

export default JVReport;
